import gql from 'graphql-tag'
import { graphql } from '@apollo/client/react/hoc'
import './RiskTab.css'
import RiskInsuranceDetails from "./RiskInsuranceDetails"
import RiskSubscriptionDetails from "./RiskSubscriptionDetails"
import RiskIntegrationDetails from "./RiskIntegrationDetails"
import withApolloClient from "../../../../../withApolloClient"
import RiskDrivingProfile from "./RiskDrivingProfile"
import Trips from "./Trips/Trips"

const DriverQuery = gql`query Driver($id: ID!){
    driver(id: $id){
        id
        canProcessInsurance
        argyleAccountId
        palencaUserId
        currentAgreement{
            id
            type {
                id
                subtypeSet: subscriptiontypeSet {
                    edges {
                        node {
                            id
                        }
                    }
                }
            }
        }
        customerRating {
            weekendDate
            percentile
            trafficLightRating
        }
        branch{
            id
        }
    }
}`

function RiskTab(props) {
    const { driver, loading, currentUser } = props
    if (loading || !driver || !currentUser) return <div></div>

    return (
        <div className="tab-container">
            <div className="row" style={{ justifyContent: "space-between" }}>
                <div className="col-7 info-container">
                    <RiskInsuranceDetails currentUser={currentUser} driver={driver} />
                </div>
                <div className="col-4 info-container">
                    <RiskSubscriptionDetails currentUser={currentUser} driver={driver} />
                </div>
            </div>
            <div className="row" style={{ justifyContent: "space-between" }}>
                <div className="col-7 info-container">
                    <RiskIntegrationDetails
                        currentUser={currentUser}
                        driver={driver}
                        palencaUserId={driver.palencaUserId}
                        argyleUserId={driver.argyleAccountId}
                    />
                </div>
                <div className="col-4 info-container">
                    <RiskDrivingProfile driver={driver} />
                </div>
            </div>
            <div className="row mt-2" style={{ justifyContent: "space-between" }}>
                <div className="col-7 info-container">
                    <Trips driverId={driver.id} />
                </div>
            </div>
        </div>
    )
}

export default
    graphql(DriverQuery, {
        options: ({ driverId }) => ({ variables: { id: driverId }, fetchPolicy: 'cache-and-network' }),
        props({ data: { driver, loading, variables } }) {
            return {
                driver, loading, variables
            }
        }
    })(withApolloClient(RiskTab)
    )
